import React from 'react';
import { ArrowRightIcon } from 'icons';
import Link from 'next/link';
import { useTranslations } from 'next-intl';

interface IProps {
  title?: string;
  path?: string;
  onChange?: () => void;
  children: React.ReactNode;
}

const SectionWrapper: React.FC<IProps> = ({ title, path, children, onChange }) => {
  const t = useTranslations();

  return (
    <div className="mt-8 space-y-4">
      <div className="flex items-center justify-between">
        <h2 className="font-semibold">{title}</h2>
        {path && (
          <Link
            href={path}
            onClick={onChange}
            className="flex items-center gap-2 text-sm font-medium text-green-500 hover:underline"
          >
            {t('barchasi')} <ArrowRightIcon />
          </Link>
        )}
      </div>

      {children}
    </div>
  );
};

export default SectionWrapper;
